<template>
  <div class="wrap">
    <span class="contact-status"></span>
    <img :src="c.logo" alt="" />
    <div class="meta">
      <p class="name">{{ c.name }}</p>
      <p class="preview"><i class="fa fa-map-marker" /> {{ c.location }} . {{ c.industry }}</p>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import moment from 'moment'

export default {
  name: 'Company',
  props: ['c'],
  data: function() {
  return {
  }
  },
  computed: {
    status: function() {
    }
  },
  methods: {
    
  },
  created: function() {
  }
}
</script>
